import { AccessChangesTable } from './access-changes-table';
import { AccessStatistics } from './access-statistics/AccessStatistics';
import { ApiVolumeGraph } from './api-volume/ApiVolumeGraph';
import { AppStatusTable } from './application-status';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DataSecurityViewContainer } from './DataSecurityViewContainer';
import { DataSecurityViewQueryParams } from './DataSecurityView';
import { DetectedApplications } from './detected-applications';
import { IncidentLogTable } from './incident-log-table';
import React from 'react';
import { SystemOverview } from './system-overview';
import { UptimeMonitorsDashboard } from './uptime-monitors-dashboard';
import { VerticalColumn } from '@ui/general/VerticalColumn';

export interface DataSecurityDashboardProps {
	viewParams: DataSecurityViewQueryParams;
	onViewChange: (params: DataSecurityViewQueryParams) => void;
}

export const DataSecurityDashboard: React.FC<DataSecurityDashboardProps> = ({ viewParams, onViewChange }) =>
	<DataSecurityViewContainer
		onViewChange={ onViewChange }
		title={ COPY_SPECIFIC.DASHBOARD }
		viewParams={ viewParams }>
		<VerticalColumn>
			<UptimeMonitorsDashboard />
			<SystemOverview />
			<DetectedApplications />
		</VerticalColumn>
		<VerticalColumn>
			<ApiVolumeGraph
				showExploreButton
				viewParams={ viewParams } />
			<AccessStatistics viewParams={ viewParams } />
			<AccessChangesTable viewParams={ viewParams } />
			<div className='column-row'>
				<AppStatusTable />
				<IncidentLogTable viewParams={ viewParams } />
			</div>
		</VerticalColumn>
	</DataSecurityViewContainer>;
